import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';

import { colors } from '../../styles';
import { TabProps } from './props';
import { Tab } from './';

export interface Props {
  tabs: TabProps[];
  className?: string;
}

class TabBar extends React.Component<Props, any> {
  public render() {
    const { className, tabs } = this.props;

    return (
      <div className={className}>
        {tabs.map((tab, index) => (
          <Tab key={`tab-${index}`} {...tab} />
        ))}
      </div>
    );
  }
}

const StyledTabBar = styled(TabBar)`
  align-items: stretch;
  border-radius: 6px;
  border: 1px solid ${colors.grey100};
  display: flex;
  flex-basis: min-content;
  overflow: hidden;
`;

export default StyledTabBar;
